// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bgz_a bhp_ea bhp_a","LoadingSwitch__init":"bgz_b bhp_a bhp_w bhp_j bhp_ul bhp_um bhp_fm"};